import { Component, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { DataService } from 'src/shared/data/data.service';
import { HttpClient } from '@angular/common/http';
 
 
@Component({
    selector: 'app-partner',
    templateUrl: './partner.component.html',
    styleUrls: ['./partner.component.scss']
})
export class PartnerComponent implements OnInit {
    @ViewChild('categoryList') categoryList: ElementRef | undefined;
    
    categories: any[] = [];
    activeCategory: any = null;
    megaMenuLeft: string = '0px';
    megaMenuWidth: string = '100vw';
    constructor(
        public data: DataService,
        private http: HttpClient,
    ) {
        
     }
    ngOnInit(): void {
        this.fetchCategories();
    }
 
    /**
     * Capitalizes the first letter of each word in a string
     * @param str - The input string to capitalize
     * @returns The string with first letter of each word capitalized
     */
    capitalizeFirstLetter(str: string): string {
        if (!str) return '';
        return str.toLowerCase().split(' ').map(word => {
            return word.charAt(0).toUpperCase() + word.slice(1);
        }).join(' ');
    }
 
    /**
     * Processes categories and subcategories to capitalize first letters
     * @param categories - Array of category objects
     * @returns Processed categories with capitalized names
     */
    processCategories(categories: any[]): any[] {
        return categories.map(category => ({
            ...category,
            name: this.capitalizeFirstLetter(category.name),
            subcategories: category.subcategories ? category.subcategories.map((subcategory: { name: string; }) => ({
                ...subcategory,
                name: this.capitalizeFirstLetter(subcategory.name)
            })) : []
        }));
    }
 
    fetchCategories(): void {
        this.http.post(this.data.base_url + 'product_menu/', {}).subscribe({
            next: (response: any) => {
                console.log('Received submenu data:', response.categories);
                // Process categories to capitalize first letters
                this.categories = this.processCategories(response.categories);           
            },
            error: (err) => {
                console.error('Error fetching submenu data:', err);
               
            }
        });
    }
 
    // onCategoryMouseEnter(category: any, categoryEl: HTMLElement) {
    //     this.activeCategory = category;
    //     const rect = categoryEl.getBoundingClientRect();
    //     // Calculate how far the left edge of the category is from the viewport
    //     const left = rect.left;
    //     this.megaMenuLeft = `-${left}px`;
    //     this.megaMenuWidth = '100vw';
    // }
 timeoutRef: any;

onCategoryMouseEnter(category: any, categoryEl: HTMLElement) {
  clearTimeout(this.timeoutRef);

  this.activeCategory = category;

  const rect = categoryEl.getBoundingClientRect();
  const left = rect.left;
  this.megaMenuLeft = `-${left}px`;
  this.megaMenuWidth = '100vw';
}

onNavMouseLeave() {
  this.timeoutRef = setTimeout(() => {
    this.activeCategory = null;
  }, 300); // delay
}
    onCategoryMouseLeave() {
        this.activeCategory = null;
    }
 
    partnerSlidesOptions: OwlOptions = {
        loop: false,
        nav: true,
        dots: false,
        autoplayHoverPause: true,
        autoplay: false,
        margin: 0,
        navText: [
            "<i class='bx bx-left-arrow-alt'></i>",
            "<i class='bx bx-right-arrow-alt'></i>"
        ],
        responsive: {
            0: {
                items: 5
            },
            576: {
                items: 5
            },
            768: {
                items: 4
            },
            1024: {
                items: 8
            }
        }
    }

scrollLeft() {
  const el = this.categoryList?.nativeElement;
  if (!el) return;
  el.scrollBy({ left: -200, behavior: 'smooth' });
}

scrollRight() {
  const el = this.categoryList?.nativeElement;
  if (!el) return;
  el.scrollBy({ left: 200, behavior: 'smooth' });
}

}